import { useCallback } from 'react';

import { transformCurrency } from '@givebacks/utils/currency';

const useCurrencyHandler = () => {
  const _transform = useCallback((value: number | string, method: 'cents' | 'dollars') => {
    const _val = transformCurrency(value, method);
    return _val;
  }, []);

  return { transform: _transform }; // The nice thing about transform is that it takes care of the value casting for us.
};

export { useCurrencyHandler };
